interface INamed {
    name: string;
}

const byStringValue =
    <T extends unknown>(getStringValue: (item: T) => string) =>
    (left: T, right: T) => {
        const leftValue = getStringValue(left);
        const rightValue = getStringValue(right);

        if (leftValue && rightValue) {
            return leftValue.localeCompare(rightValue);
        }

        if (!(leftValue || rightValue)) return 0;
        return leftValue ? 1 : -1;
    };

const byName = byStringValue<INamed>(item => item.name);

const byNumericValue =
    <T extends unknown>(getNumericValue: (item: T) => number) =>
    (left: T, right: T) => {
        return getNumericValue(left) - getNumericValue(right);
    };

const compare = {
    byName,
    byStringValue,
    byNumericValue,
};

export default compare;
